export default {
  presenter: 'encounter',
  title: 'Encounter',
  subtitle: '',
  text: `
Jde o diskuzi v kruhu, kde se řeší konkrétní problémy účastníků za účasti dvou facilitátorů. Encounterová skupina je způsob, jak pracovat na svém osobnostním růstu. Znamená to větší porozumění sobě, vyjasňování vztahů s ostatními nebo aktivní utváření vlastního života. Děje se tak díky přímé interakci s lidmi ve skupině bez předem daného scénáře. Postupně budovaná důvěra umožňuje účastníkům časem odložit společenské masky a otevřeně a pravdivě projevovat své emoce a postoje – souhlas, kritiku, radost, podráždění, náklonnost, smutek…
  `,
}



// WEBPACK FOOTER //
// ./src/content/devdata/data/presentations/c01_encounter.js